'use client'

import { useLessonViewModel } from '@entities/lesson'

import { Box, HStack } from '@podo-app/design-system-temp'

export const PreStudyProgress = () => {
  const { viewModel } = useLessonViewModel()

  return (
    <HStack className="w-full h-2.5 bg-gray-100 rounded-[14px] overflow-hidden" data-testid="prestudy-progress-bar">
      <Box
        className="h-full bg-green-500"
        style={{ width: `${viewModel.progress}%` }}
        data-testid="prestudy-progress-fill"
        data-progress={viewModel.progress}
      />
    </HStack>
  )
}
